<template>
  <div class="about-dialog" style="position:absolute; left: 0%; top: 20px; height: 50px; width:250px; z-index: 2000;
  display: flex; flex-direction: column; justify-content: center;">
    <!-- <button class="btn btn-success w-100" @click="dialogVideoVisible = true"> -->
    <el-button type="success" size="large" @click="dialogVideoVisible = true"
               style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
      <img src="video.svg" class="tool-img me-2">
      About
    <!-- </button> -->
  </el-button>
  
    <el-dialog v-model="dialogVideoVisible" title="Introduction to ARCH Network" width="70%" @closed="closeVideoDialog" align-center>
      <div>
        <el-scrollbar max-height="700px">
          <video id="dialog_video" src="Intro to ARCH.mp4" controls="controls" style="width: 60%; margin-top: 16px"></video>
          <div style="width:100%; display: flex; flex-direction: column; align-items: center;">
            <div v-html="renderedContent" style="width:70%; text-align: left; margin-bottom: 16px; line-height: 1.7"></div>
          </div>
        </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import markdownit from 'markdown-it';

const dialogVideoVisible = ref(false);
const renderedContent = ref('');
const md = markdownit();

function closeVideoDialog() {
  pauseVideo();
}

function pauseVideo() {
  const videoInstance = document.getElementById("dialog_video");
  if (videoInstance && !videoInstance.paused) {
    videoInstance.pause();
  }
}

function loadMarkdownFile() {
  axios.get("./About.md")
    .then(res => {
      renderedContent.value = md.render(res.data);
    }).catch(err => {
      console.error('Failed to load Markdown file:', err);
    });
}

onMounted(() => {
  loadMarkdownFile();
});
</script>

<style scoped>

/* .about-dialog {

  position: absolute; 
  left: 0; 
  width: 250px; 
  top: 10px; 
  height: 50px; 
  z-index: 2000; 
  display: flex; 
  justify-content: center; 
  flex-direction: column; 
  align-items: center; 
  overflow: hidden; 

} */


.tool-img {
  height: 1.2rem;
  width: 1.2rem;
  margin-right: 8px;
  filter: brightness(0) invert(1);
  opacity: 1;
}

</style>
